<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path d="M18.39 68.638h3.81l-1.905-4.849z" />
      <path
        d="M49.484 76.208h4.696V58.06h-4.696v18.148zm21.723 17.274H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zM27.938 58.06h5.191l4.539 11.822 4.565-11.822h5.113l-7.487 18.252h-4.46L27.938 58.06zm2.322 18.148h-5.035l-1.539-3.837h-6.782l-1.54 3.837H10.41l7.669-18.252h4.513l7.669 18.252zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.706-4.773 10.706-10.643V25.19L56.48 0z"
      />
      <path
        d="M42.092 25.235l-12.517-8.517c-.578-.393-1.16-.602-1.644-.602-.936 0-1.515.747-1.515 1.997V36.52c0 1.248.578 1.993 1.512 1.993.484 0 1.058-.208 1.637-.603l12.523-8.517c.805-.548 1.251-1.286 1.251-2.08 0-.791-.44-1.53-1.247-2.078"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-avi',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
